export default "__VITE_ASSET__W9AhjblT__"